import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, CreditCard, BarChart3, LogOut, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const Sidebar = () => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const menuItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/cards', icon: CreditCard, label: 'Mes Cartes' },
    { path: '/analytics', icon: BarChart3, label: 'Analytics' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="w-64 h-screen flex flex-col glass border-r border-white/10" style={{ backgroundColor: 'rgba(11, 15, 18, 0.8)', backdropFilter: 'blur(20px)' }}>
      {/* Logo */}
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center" 
               style={{ background: 'linear-gradient(135deg, var(--primary-pearl-blue), var(--accent-blue-gray))' }}>
            <span className="text-black font-bold text-xl heading-display">A</span>
          </div>
          <div>
            <h1 className="text-white font-bold text-lg heading-display">ATOM Group</h1>
            <p className="text-gray-400 text-xs">Digital Cards</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <div className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-xl transition-all ${
                  isActive(item.path)
                    ? 'glass text-white'
                    : 'text-gray-400 hover:glass hover:text-white'
                }`}
                style={isActive(item.path) ? { background: 'linear-gradient(135deg, rgba(207, 232, 255, 0.1), rgba(187, 210, 232, 0.1))' } : {}}
              >
                <Icon size={20} />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>

      {/* User Section */}
      <div className="p-4 border-t border-white/10">
        <div className="flex items-center justify-between glass p-3 rounded-xl">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 rounded-full flex items-center justify-center" 
                 style={{ background: 'linear-gradient(135deg, var(--primary-pearl-blue), var(--accent-blue-gray))' }}>
              <User size={16} className="text-black" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-medium truncate">{user?.full_name}</p>
              <p className="text-gray-400 text-xs truncate">{user?.email}</p>
            </div>
          </div>
          <button
            onClick={logout}
            className="p-2 text-gray-400 hover:text-white glass hover:bg-white/10 rounded-lg transition-all"
            title="Déconnexion"
          >
            <LogOut size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
